export default "__VITE_ASSET__gvwvpd38__"